import {firebaseAction} from 'vuexfire'
import firebase from 'firebase/app';
import {EventBus} from "../util/event-bus";

export default {
    namespaced: true,
    state: {
        list: [],

    },
    getters: {},
    mutations: {},
    actions: {

        //BINDINGS

        setList: firebaseAction(({bindFirebaseRef}, ref) => {
            return new Promise(resolve => {
                bindFirebaseRef('list', ref, {
                    readyCallback() {
                        resolve();
                    }
                })
            })
        }),
        createLink: function (context, link) {
            return new Promise((resolve) => {

                let payload = link.link;
                let id = firebase.database().ref().push().key;

                console.log(payload)

                firebase.database().ref('link').child(id).set(payload).then(() => {
                    resolve(id)
                });
            })
        },
        updateLink: function (context, data) {
            data = data.data;//???
            return new Promise(resolve => {
                firebase.database().ref('link/' + data.id).update({
                    name: data.name,
                    link: data.link,
                }).then(() => resolve());
            });
        },
        deleteLink: function ( context, {id}) {
            return firebase.database().ref('/link').child(id).remove();
        },
    }

}
